import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'modal-alert',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() type: 'success' | 'warning' | 'error' = 'success';
  @Input() title: string = 'Confirm';
  @Input() message: string = 'Are you sure?';
  @Output() close = new EventEmitter<boolean>();
  @Output() continue = new EventEmitter<boolean>();

  onClose() {
    this.close.emit(false);
  }

  onContinue() {
    this.continue.emit(true);
  }
}
